import { Button, HStack, Heading, Stack } from '@chakra-ui/react';
import { DataTable, EmptyTable } from 'components';
import { customerFormTypes, deliveryType } from 'types';

import { Link as DefaultLink } from 'react-router-dom';
import React from 'react';
import { createColumnHelper } from '@tanstack/react-table';

type customerTableProps = {
    customers: Array<deliveryType>;
};

export const CustomerTable = (props: customerTableProps) => {

    const { customers = [] } = props;

    const data: customerFormTypes[] = customers.slice(0, 5);

    const columnHelper = createColumnHelper<customerFormTypes>();

    const columns = [
        columnHelper.accessor('customer_id', {
            cell: (info) => info.getValue(),
            header: 'Customer ID'
        }),
        columnHelper.accessor('', {
            cell: ({ row }) => <span>{`${row?.original?.first_name} ${row?.original?.last_name}`}</span>,
            header: 'Fullname'
        }),
        columnHelper.accessor('email', {
            cell: (info) => info.getValue(),
            header: 'Email'
        }),
        columnHelper.accessor('phone', {
            cell: (info) => info.getValue(),
            header: 'Phone',
        })
    ];

    return (
        <Stack bg={'#FFFFFF'} p={4} borderRadius={6} mt={3}>
            <HStack justifyContent={'space-between'}>
                <Heading size={'sm'} fontWeight={'semibold'}>Customers</Heading>
                <Button size={'xs'} variant={'outline'} colorScheme={'yellow'} as={DefaultLink} to={'/customers'}>
                    View All
                </Button>
            </HStack>
            <Stack>
                <DataTable columns={columns} data={data} showPagination={false} showSearch={false} />
                {!customers.length && <EmptyTable title='Oops!' description='Your company does not have customers.' />}
            </Stack>
        </Stack>
    );
};